export const userActionFiredAction = (action: string) => ({
  type: 'USER_ACTION_FIRED',
  payload: {
    action,
  },
});
